import { RequestTagData } from './types';
import { OrganizationManager } from '@shared/model/organization';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { RequestListItem, RequestStatus } from '@shared/model/request';

export const requestStatusTag = ({
    request,
    manager,
}: {
    request: RequestListItem;
    manager?: OrganizationManager | null;
}): RequestTagData | null => {
    const managerName = userName({
        firstName: manager?.firstName,
        lastName: manager?.lastName,
        middleName: manager?.middleName,
    });

    const declineMessage = {
        message: request.comment || '',
        managerName: managerName.full,
        managerAvatarUrl: manager?.photoUrl || '',
    };

    switch (request.status) {
        case RequestStatus.New: {
            return {
                text: 'На рассмотрении',
                variant: 'blue',
            };
        }
        case RequestStatus.OrderForming: {
            return {
                text: 'Согласовано',
                variant: 'grey',
            };
        }
        default: {
            return {
                text: 'Отклонено',
                variant: 'declined',
                declineMessage,
            };
        }
    }

    return null;
};
